export default __webpack_public_path__ + "static/media/Inter-Light.eec86646.ttf";